import type { MouseEventHandler } from 'react';

import type { Nil, Unit, UserPreferredUnit } from '@core';

import { ParameterCard } from '../ParameterCard/ParameterCard';
import { useParameters } from '../ParameterCard/useParameters';
import { SelectBox } from '../SelectBox/SelectBox';

export type ParameterSelectionCardProps = {
    title: string;
    unit: Unit;
    userPreferredUnit: UserPreferredUnit;
    value: number | Nil;
    comparisonValue?: number | Nil;
    isSelected: boolean;
    onClick?: MouseEventHandler<HTMLDivElement>;
};

type ParameterSelectionCardBaseProps = ParameterSelectionCardProps & {
    compact?: boolean;
};

export type CompactParameterSelectionCardProps = ParameterSelectionCardProps;

export const ParameterSelectionCard = ({
    title,
    unit,
    userPreferredUnit,
    value,
    comparisonValue,
    isSelected,
    onClick,
    compact = false,
}: ParameterSelectionCardBaseProps) => {
    const converted = useParameters({
        unit,
        value,
        comparisonValue,
        userPreferredUnit,
        mean: undefined,
        stdDev: undefined,
    });

    return (
        <ParameterCard.Root small compact={compact} onClick={onClick}>
            <ParameterCard.Title startSlot={<SelectBox color="gray" selected={isSelected} />}>
                {title}
            </ParameterCard.Title>
            <ParameterCard.Values>
                <ParameterCard.Value
                    displayUnit={converted.unit}
                    symbol={converted.symbol}
                    value={converted.value}
                    indicatorColor={converted.corridorIndicatorColor}
                />
                <ParameterCard.Comparison
                    displayUnit={converted.unit}
                    symbol={converted.symbol}
                    value={converted.comparison}
                />
            </ParameterCard.Values>
        </ParameterCard.Root>
    );
};

export const CompactParameterSelectionCard = (props: CompactParameterSelectionCardProps) => (
    <ParameterSelectionCard {...props} compact />
);
